<template>
    <div class="container-fluid">
        <notice-details
            :item="selectedRow"
            :show-notice-details-modal="noticeDetailsModal"
            @submit="handleNoticeDetailsModalDismiss(true)"
            @dismiss="handleNoticeDetailsModalDismiss(false)"></notice-details>
        <b-grid
            caption="All Notices"
            :filterableFields="noticeStore.filterableNoticeFields"
            :filterOptions="noticeStore.noticeFilterOptions"
            :tableOptions="noticeStore.allNoticesTableOptions"
            :items="noticeStore.noticeItems"
            :columns="noticeStore.columns"
            :show-filter="true"
            :show-paging="true"
            :current-item-count="noticeStore.allNoticesTableOptions.totalItemCount"
            @optionChange="noticeStore.allNotices">
            <template #cell.agencyList="{item, column}">
                <!--We can include the full list of oris in a tooltip here by using item.agencyList-->
                <span class="ori-label">{{ item.ori }}</span>
            </template>
            <template #header.dismissed="{column}">
                <div class="w-100 text-center">
                    {{ column.text }}
                </div>
            </template>
            <template #cell.dismissed="{item, column}">
                <div class="w-100 text-center">
                    <input
                        class=""
                        disabled="true"
                        readonly
                        type="checkbox"
                        :checked="item.is_dismissed" />
                </div>
            </template>
            <template v-slot:cell.description="{item, column}">
                <button
                    type="button"
                    class="btn btn-link ps-0"
                    @click.prevent="handleDescriptionClick(item)">
                    {{ item.description }}
                </button>
            </template>
        </b-grid>
    </div>
</template>
<script setup lang="ts">
import {computed, ref, onMounted, watch} from "vue";
import BGrid from "../BGrid/BGrid.vue";
import {useNoticeStore} from "@/stores/noticeStore";
import {NoticeItem} from "./types";
import NoticeDetails from "./NoticeDetails.vue";
import InformationModal from "../Misc/InformationModal.vue";
import {BFilter} from "../BFilterEditor/BFilterEditor.types";
import hasPermission from "@/composable/permissionHelper";
import {useOriStore} from "@/stores/oriStore";

const noticeStore = useNoticeStore();

var selectedRow = ref({} as NoticeItem);
var noticeDetailsModal = ref(false);

var oriStore = useOriStore();
oriStore.dataset = undefined;

function handleDescriptionClick(item: NoticeItem) {
    selectedRow.value = item;
    noticeDetailsModal.value = true;
}

async function handleNoticeDetailsModalDismiss(isSubmit: boolean) {
    selectedRow.value = {} as NoticeItem;
    noticeDetailsModal.value = false;

    if (isSubmit) {
        await noticeStore.allNotices();
    }
}

onMounted(async () => {

    noticeStore.noticeFilterOptions.filters = [{property: "is_dismissed", operation: "eq", value: false} as BFilter];
    await noticeStore.allNotices();
});
</script>
